import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UploadComponent } from 'src/app/components/system-config/charges/upload/upload.component'; 
import { AddChargesComponent } from 'src/app/components/system-config/charges/manage/add/add.component';
import { EditChargesComponent } from 'src/app/components/system-config/charges/manage/edit/edit.component';
import { ListChargesComponent } from 'src/app/components/system-config/charges/manage/list/list.component';
import { FuelSurchargesComponent } from 'src/app/components/system-config/charges/fuelsurcharges/fuelsurcharges.component';
import { ODAChargesComponent } from 'src/app/components/system-config/charges/oda/oda.component';
const routes: Routes = [
    { path: 'upload', component: UploadComponent },
    { path: 'manage', component: ListChargesComponent },
    { path: 'manage/add', component: AddChargesComponent },
    { path: 'manage/edit/:id', component: EditChargesComponent },
    { path: 'fuelsurcharges', component: FuelSurchargesComponent },
    { path: 'oda', component: ODAChargesComponent },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ChargesRoutingModule { }

